import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useGet } from '../../HttpClient';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { pillarCode } from './UseCategories';

export function useServiceUserNumbers(organisationUnitId: string) {
  const get = useGet(true, pillarCode);
  const getServiceUserNumbers = async (organisationUnitId: string) => get<ServiceUser[]>(`${tenantHierarchyBaseUrl}/organisation-units/${organisationUnitId}/category/regular-payments/rules/ServiceUser`);

  return useQueryWithErrorHandling({
    queryKey: ['serviceUserNumbers', organisationUnitId],
    queryFn: async () => await getServiceUserNumbers(organisationUnitId),
  });
}

type ServiceUser  = {
    id: string,
    name: string,
    createdDate: string,
    updatedDate: string,
    description: string,
    properties: ServiceUserProperties,
    category: string
}

type ServiceUserProperties = {
    Id: string,
    Name: string,
    SortCode: string,
    AccountNumber: string
}